import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = ["body", "toggle"]
    _idIsCollapsed = "is-collapsed";

    connect() {
        super.connect()
        this.updateToggleStatus()
    }

    toggle(event) {
        event.preventDefault()
        this.element.classList.toggle(this._idIsCollapsed)
        this.updateToggleStatus()
    }

    updateToggleStatus() {
        if (this.hasBodyTarget) {
            this.bodyTarget.hidden = this.element.classList.contains(this._idIsCollapsed)
        }
    }
}
